import { useExportBulkImportJobRowsStatusSubscription } from '@/types/generated/graphql';
import { downloadBlobFile } from '@/shared/utils/download-blob-file';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';

export function useExportBulkImportJobRowsSubscription() {
  const { t } = useTranslation();
  useExportBulkImportJobRowsStatusSubscription({
    onData: ({ data }) => {
      const exportData = data.data?.exportBulkImportJobRowsStatus?.data;
      if (exportData?.url) {
        downloadBlobFile(fetch(exportData?.url), {
          fileName: exportData?.originalname || 'contacts.csv',
        });
        notification.success({
          message: t('export_complete'),
          description: t('export_complete_file_ready_for_download'),
        });
      }
    },
  });
}
